import React, { useRef } from "react";
import { useParams, NavLink, Switch } from "react-router-dom";
import CustomerOverviewPage from "@icoach/nonMember/customer/CustomerOverviewPage";
import ProspectOverviewPage from "@icoach/nonMember/prospect/ProspectOverviewPage";
import TemporariesOverviewPage from "@icoach/nonMember/temporary/TemporariesOverviewPage";
import useMenusControlled from "@util/hook/useMenusControlled";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { NONMEMBER_TABS } from "@constants/appConfig";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
import { Icons } from "@curves/ui-base";
import PageLayout from "@icoach/components/layout/PageLayout";
import NonMemberDialogBox from "@icoach/nonMember/dialog/NonMemberDialogBox";

const NonMemberPage = props => {
	const { tabs: activeTab } = useParams();
	const dialogRef = useRef(null);
	const pageTabs = useMenusControlled([
		{
			label: "顧客總覽",
			component: NavLink,
			frontKey: "C3X02",
			to: NON_MEMBER_ROUTER.CUSTOMER.OVERVIEW,
			value: NONMEMBER_TABS.CUSTOMER,
			icon: Icons.UserCircle,
		},
		{
			label: "名單總覽",
			component: NavLink,
			frontKey: "C3X04",
			to: NON_MEMBER_ROUTER.PROSPECT.OVERVIEW,
			value: NONMEMBER_TABS.PROSPECT,
			icon: Icons.UserCircle,
		},
		{
			label: "暫存名單",
			component: NavLink,
			frontKey: "C3X06",
			to: NON_MEMBER_ROUTER.TEMPORARIES.OVERVIEW,
			value: NONMEMBER_TABS.TEMPORARIES,
			icon: Icons.UserCircle,
		},
	]);
	const pageActions = useMenusControlled([
		{
			label: "新增詢問",
			frontKey: "C3X03",
			variant: "outlined",
			as: NavLink,
			to: NON_MEMBER_ROUTER.CUSTOMER.ADD_BASE,
		},
		{
			label: "新增名單",
			frontKey: "C3X05",
			variant: "contained",
			as: NavLink,
			to: NON_MEMBER_ROUTER.PROSPECT.ADD_BASE,
		},
	]);

	return (
		<PageLayout className="non-member-container">
			<PageLayout.Tabs tabs={pageTabs} activeTab={NONMEMBER_TABS[String(activeTab).toLocaleUpperCase()]} actions={pageActions} />
			<Switch>
				<PrivateRoute path={NON_MEMBER_ROUTER.CUSTOMER.OVERVIEW} as={CustomerOverviewPage} dialogRef={dialogRef} exact />
				<PrivateRoute path={NON_MEMBER_ROUTER.PROSPECT.OVERVIEW} as={ProspectOverviewPage} dialogRef={dialogRef} exact />
				<PrivateRoute path={NON_MEMBER_ROUTER.TEMPORARIES.OVERVIEW} as={TemporariesOverviewPage} dialogRef={dialogRef} exact />
			</Switch>
			<NonMemberDialogBox ref={dialogRef} />
		</PageLayout>
	);
};

export default NonMemberPage;
